export default function({language}) {
    var config = {
        type: "text-field",
        placeholder: "5,5%",
        show: [{ has_mortgage_debt: "Ja" }],
        format: "decimal",
        suffix: "%",
    };

    return {
        config,
        extendsType: "text-field"
    };
};
